import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../styles/ArticlePage.css';
import { useTranslation } from 'react-i18next';

const ArticlePage = () => {
  const { articleId } = useParams();
  const { t } = useTranslation();
  
  useEffect(() => {
    // Scroll to top when article loads
    window.scrollTo(0, 0);
  }, [articleId]);

  return (
    <div className="article-page-container">
      {/* Article content will be rendered dynamically based on the articleId */}
      {articleId === 'ampyfin-v1-release' && (
        <div className="article-content">
          <div className="article-header">
            <div className="article-date">{t('articles.v1.date')}</div>
            <h1>{t('articles.v1.title')}</h1>
          </div>
          
          <div className="article-badge">v1.0.1</div>
          
          <div className="v1-animation">
            <div className="wave"></div>
          </div>
          
          <div className="article-body">
            <p>
              {t('articles.v1.p1')}
            </p>
            
            <p>
              {t('articles.v1.p2')}
            </p>
            
            <p>
              {t('articles.v1.p3')}
            </p>
            
            <p>
              {t('articles.v1.p4')}
            </p>
            
            <p>
              {t('articles.v1.p5')}
            </p>
            
            <div className="article-footer">
              <p>{t('articles.team')}</p>
            </div>
          </div>
        </div>
      )}
      
      {articleId === 'ampyfin-v2-release' && (
        <div className="article-content">
          <div className="article-header">
            <div className="article-date">{t('articles.v2.date')}</div>
            <h1>{t('articles.v2.title')}</h1>
          </div>
          
          <div className="article-badge">v2.0.1</div>
          
          <div className="v2-animation">
            <div className="model-dot prag-dot"></div>
            <div className="model-dot hyper-dot"></div>
            <div className="model-dot euler-dot"></div>
            <div className="model-dot tachyon-dot"></div>
            <div className="model-dot aether-dot"></div>
          </div>
          
          <div className="article-body">
            <p>
              {t('articles.v2.p1')}
            </p>
            
            <p>
              {t('articles.v2.p2')}
            </p>
            
            <p>
              {t('articles.v2.p3')}
            </p>
            
            <p>
              {t('articles.v2.p4')}
            </p>
            
            <p>
              {t('articles.v2.p5')}
            </p>
            
            <p>
              {t('articles.v2.p6')}
            </p>
            
            <div className="article-footer">
              <p>{t('articles.team')}</p>
            </div>
          </div>
        </div>
      )}
      
      {articleId === 'ampyfin-v3-release' && (
        <div className="article-content">
          <div className="article-header">
            <div className="article-date">{t('articles.v3.date')}</div>
            <h1>{t('articles.v3.title')}</h1>
          </div>
          
          <div className="article-badge">v3.0.1</div>
          
          <div className="v3-animation">
            <div className="llm-pulse riemann-pulse"></div>
            <div className="llm-pulse sigma-pulse"></div>
          </div>
          
          <div className="article-body">
            <p>
              {t('articles.v3.p1')}
            </p>
            
            <p>
              {t('articles.v3.p2')}
            </p>
            
            <p>
              {t('articles.v3.p3')}
            </p>
            
            <p>
              {t('articles.v3.p4')}
            </p>
            
            <p>
              {t('articles.v3.p5')}
            </p>
            
            <p>
              {t('articles.v3.p6')}
            </p>
            
            <p>
              {t('articles.v3.p7')}
            </p>
            
            <p>
              {t('articles.v3.p8')}
            </p>
            
            <div className="article-footer">
              <p>{t('articles.team')}</p>
            </div>
          </div>
        </div>
      )}
      
      {articleId === 'ampyfin-v4-release' && (
        <div className="article-content">
          <div className="article-header">
            <div className="article-date">{t('articles.v4.date')}</div>
            <h1>{t('articles.v4.title')}</h1>
          </div>
          
          <div className="article-badge">v4.0.1</div>
          
          <div className="v4-animation">
            <div className="parameter-line line1"></div>
            <div className="parameter-line line2"></div>
            <div className="parameter-line line3"></div>
            <div className="parameter-line line4"></div>
            <div className="parameter-line line5"></div>
            <div className="parameter-line line6"></div>
            <div className="parameter-line line7"></div>
            <div className="parameter-line line8"></div>
          </div>
          
          <div className="article-body">
            <p>
              {t('articles.v4.p1')}
            </p>
            
            <p>
              {t('articles.v4.p2')}
            </p>
            
            <p>
              {t('articles.v4.p3')}
            </p>
            
            <p>
              {t('articles.v4.p4')}
            </p>
            
            <p>
              {t('articles.v4.p5')}
            </p>
            
            <p>
              {t('articles.v4.p6')}
            </p>
            
            <p>
              {t('articles.v4.p7')}
            </p>
            
            <p>
              {t('articles.v4.p8')}
            </p>
            
            <p>
              {t('articles.v4.p9')}
            </p>
            
            <p>
              {t('articles.v4.p10')}
            </p>
            
            <div className="article-footer">
              <p>{t('articles.team')}</p>
            </div>
          </div>
        </div>
      )}
      
      {articleId === 'open-source-models' && (
        <div className="article-content">
          <div className="article-header">
            <div className="article-date">{t('articles.openSourceModels.date')}</div>
            <h1>{t('articles.openSourceModels.title')}</h1>
          </div>
          
          <div className="article-badge">{t('articles.openSourceModels.badge')}</div>
          
          <div className="open-source-animation">
            <div className="github-icon"></div>
          </div>
          
          <div className="article-body">
            <p>
              {t('articles.openSourceModels.p1')}
            </p>
            
            <h3>{t('articles.openSourceModels.h1')}</h3>
            <p>
              {t('articles.openSourceModels.p2')}
            </p>
            
            <p>
              {t('articles.openSourceModels.p3')}
            </p>
            
            <h3>{t('articles.openSourceModels.h2')}</h3>
            <p>
              {t('articles.openSourceModels.p4')}
            </p>
            
            <p>
              {t('articles.openSourceModels.p5')}
            </p>
            
            <h3>{t('articles.openSourceModels.h3')}</h3>
            <p>
              {t('articles.openSourceModels.p6')}
            </p>
            
            <p>
              {t('articles.openSourceModels.p7')}
            </p>
            
            <h3>{t('articles.openSourceModels.h4')}</h3>
            <p>
              {t('articles.openSourceModels.p8')}
            </p>
            
            <p>
              {t('articles.openSourceModels.p9')}
            </p>
            
            <div className="article-links">
              <a href={t('articles.openSourceModels.links.euler')} target="_blank" rel="noopener noreferrer" className="github-link">
                View Euler System on GitHub →
              </a>
              <a href={t('articles.openSourceModels.links.val')} target="_blank" rel="noopener noreferrer" className="github-link">
                View Val System on GitHub →
              </a>
            </div>
            
            <div className="article-footer">
              <p>{t('articles.team')}</p>
            </div>
          </div>
        </div>
      )}
      
      {articleId === 'public-announcement' && (
        <div className="article-content">
          <div className="article-header">
            <div className="article-date">{t('articles.announcement.date')}</div>
            <h1>{t('articles.announcement.title')}</h1>
          </div>
          
          <div className="article-badge">{t('articles.announcement.badge')}</div>
          
          <div className="public-announcement-animation">
            <div className="shield"></div>
          </div>
          
          <div className="article-body">
            <p>
              {t('articles.announcement.p1')}
            </p>
            
            <h3>{t('articles.announcement.h1')}</h3>
            <p>
              {t('articles.announcement.p2')}
            </p>
            
            <p>
              {t('articles.announcement.p3')}
            </p>
            
            <h3>{t('articles.announcement.h2')}</h3>
            <p>
              {t('articles.announcement.p4')}
            </p>
            
            <h3>{t('articles.announcement.h3')}</h3>
            <p>
              {t('articles.announcement.p5')}
            </p>
            
            <p>
              {t('articles.announcement.p6')}
            </p>
            
            <h3>{t('articles.announcement.h4')}</h3>
            <p>
              {t('articles.announcement.p7')}
            </p>
            
            <p>
              {t('articles.announcement.p8')}
            </p>
            
            <div className="article-footer">
              <p>{t('articles.team')}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticlePage; 